
const whenReadyPromiseRelatedItems =
  window.CornerWebComponentsAPI?.whenReady?.call(window.CornerWebComponentsAPI) ||
  new Promise((resolve) => {
    window.CORNER_PENDING_EXTENDED_COMPONENTS = window.CORNER_PENDING_EXTENDED_COMPONENTS || [];
    window.CORNER_PENDING_EXTENDED_COMPONENTS.push(resolve);
  });

whenReadyPromiseRelatedItems.then(() => {
  const RelatedItems = window.CornerWebComponentsAPI.getClass("CornerRelatedItems");
  if (!RelatedItems) return;

  // Guard against double-patching if this snippet runs twice
  if (RelatedItems.prototype.__cornerFullTitlePatched) return;
  RelatedItems.prototype.__cornerFullTitlePatched = true;

  // Only used for the product title in card / carousel / list -> return it in full.
  RelatedItems.prototype.truncateText = function (text) {
    return text || "";
  };
});